module.exports = __webpack_public_path__ + "static/media/1010678.b2f00321.jpg";